<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="actionLoading"
        >
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Tworzenie kampanii z pliku
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" md="12" lg="12">
                            <v-file-input
                                v-model="currentFile"
                                accept=".xlsx"
                                label="Plik"
                                placeholder="Wybierz plik"
                            >
                                <template #selection="{text}">
                                    <v-chip
                                        label
                                        small
                                    >
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    :disabled="!currentFile"
                    @click="uploadFile"
                >
                    Utwórz kampanię
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'AddCampaignDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            currentFile: null,
            actionLoading: false,
        }
    },
    methods: {
        uploadFile() {
            const formData = new FormData()

            formData.append('file', this.currentFile)

            this.actionLoading = true
            this.$store.dispatch('campaigns/createCampaignByFile', formData)
                .then(response => {
                    this.$emit('campaign-created-by-file', response)
                    this.onClose()
                })
                .catch(error => {
                    if (error.message !== 'canceled') {
                        errorHandler(error)
                    }
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            setTimeout(() => {
                this.currentFile = null
                this.actionLoading = false
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>
